import axios from "axios";
import { createAxiosClient } from "./http-client.service";

export const pythonApiBaseUrl =
  process.env.REACT_APP_PYTHON_BACKEND_URL || "http://localhost:8000";

export const pythonApiClient = createAxiosClient(pythonApiBaseUrl);
export const pythonPublicClient = axios.create({ baseURL: pythonApiBaseUrl });
